import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconFilterList.tsx
const OutlinedFilledFilterList = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z" })
});
const OutlinedFilterList = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z" })
});
const RoundedFilledFilterList = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M429-190q-19.98 0-33.49-12.93Q382-215.86 382-235.84q0-19.98 13.63-34.07Q409.25-284 429-284h103q19.55 0 32.78 14.26Q578-255.47 578-235.49t-13.62 32.74Q550.75-190 531-190H429ZM264-434q-20.1 0-33.05-12.93-12.95-12.93-12.95-33t12.95-33.57Q243.9-527 264-527h431q19.97 0 33.49 13.68Q742-499.65 742-479.58t-13.51 32.83Q714.97-434 695-434H264ZM141-677q-20.1 0-33.05-13.52Q95-704.04 95-724.02t13.63-33.48Q122.25-771 142-771h677q19.97 0 33.49 13.68Q866-743.65 866-723.67q0 19.99-14.19 33.33Q837.63-677 818-677H141Z" })
});
const RoundedFilterList = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M429-190q-19.98 0-33.49-12.93Q382-215.86 382-235.84q0-19.98 13.63-34.07Q409.25-284 429-284h103q19.55 0 32.78 14.26Q578-255.47 578-235.49t-13.62 32.74Q550.75-190 531-190H429ZM264-434q-20.1 0-33.05-12.93-12.95-12.93-12.95-33t12.95-33.57Q243.9-527 264-527h431q19.97 0 33.49 13.68Q742-499.65 742-479.58t-13.51 32.83Q714.97-434 695-434H264ZM141-677q-20.1 0-33.05-13.52Q95-704.04 95-724.02t13.63-33.48Q122.25-771 142-771h677q19.97 0 33.49 13.68Q866-743.65 866-723.67q0 19.99-14.19 33.33Q837.63-677 818-677H141Z" })
});
const SharpFilledFilterList = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z" })
});
const SharpFilterList = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z" })
});
const componentMap = {
	outlined: OutlinedFilterList,
	"outlined-fill": OutlinedFilledFilterList,
	rounded: RoundedFilterList,
	"rounded-fill": RoundedFilledFilterList,
	sharp: SharpFilterList,
	"sharp-fill": SharpFilledFilterList
};
const IconFilterList = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconFilterList };